import React from 'react';
import { TableHeaderColumn, TableRow } from 'material-ui/Table';
import {
  tableHeaderColumnStyles,
  tableRowStyles,
  tableAddressColumnStyles
} from '../styles';

export default () => (
  <TableRow style={tableRowStyles}>
    <TableHeaderColumn style={tableHeaderColumnStyles}>
      REQUEST ID
    </TableHeaderColumn>
    <TableHeaderColumn style={tableHeaderColumnStyles}>
      LEASE ID
    </TableHeaderColumn>
    <TableHeaderColumn style={tableHeaderColumnStyles}>
      REGO NUMBER
    </TableHeaderColumn>
    <TableHeaderColumn style={tableHeaderColumnStyles}>
      DRIVERS NAME
    </TableHeaderColumn>
    <TableHeaderColumn
      style={{ ...tableHeaderColumnStyles, ...tableAddressColumnStyles }}>
      ADDRESS
    </TableHeaderColumn>
  </TableRow>
);



// WEBPACK FOOTER //
// ./src/features/fuel-cards/request-log-table/request-log-table-header.js